import { render, staticRenderFns } from "./receiptTimeout.vue?vue&type=template&id=e36d899c"
import script from "./receiptTimeout.vue?vue&type=script&lang=js"
export * from "./receiptTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports